module.exports = __webpack_public_path__ + "img/Mom-icons_LeadData.89c1e52f.png";